import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

export interface ContractProgressIdsInPages {
  [page: number]: string[];
}

export type ContractProgressIdsInPagesState = ContractProgressIdsInPages | null;

const initialState: ContractProgressIdsInPagesState = null;

export default function reducer(
  state: ContractProgressIdsInPagesState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return {};
    default:
      return state;
  }
}
